import { CompetitionChannelControllerApi } from '@rallycry/api-suite-typescript/dist/apis/CompetitionChannelControllerApi'
import { CompetitionChannelSaveCommand } from '@rallycry/api-suite-typescript/dist/models/CompetitionChannelSaveCommand'
import { EntityOptions, useReadEntity } from '../useEntity'
import { useParsedParam } from '@/core/hooks/useRouteParams'
import { useController } from '@/core/hooks/useSWRApi'

export const useCompetitionChannel = (options?: EntityOptions) => {
  const competitionId = useParsedParam('competitionId')
  const { ctrl } = useController(CompetitionChannelControllerApi)

  const entity = useReadEntity({
    key: 'useCompetitionChannel',
    idOrKey: competitionId,
    ...options,
    read: req =>
      ctrl({
        expectedStatuses: [404],
        fallbackResponse: null
      }).readCompetitionChannel({
        competitionId: req.id
      })
  })

  const update = async (cmd: CompetitionChannelSaveCommand) => {
    const res = await ctrl().saveCompetitionChannel({
      competitionId,
      competitionChannelSaveCommand: { syncParticipants: true, ...cmd }
    })
    await entity.read.mutate(res, false)
  }

  const remove = async () => {
    await ctrl().removeCompetitionChannel({ competitionId })
    await entity.read.mutate()
  }

  return { ...entity, channel: entity.read.data, update, remove }
}
